enum WeekOfMonth {
    First = 1,
    Second = 2,
    Third = 3,
    Fourth = 4,
    Last = 5,
}

export default WeekOfMonth;
